import type { MailboxInfo } from 'owa-client-types';
import { UserCohort } from '../store/store';
import { getUserCohort } from './getUserCohort';

export function isCohortAISKU(mailboxInfo: MailboxInfo): boolean {
    return getUserCohort(mailboxInfo) === UserCohort.BCAIS;
}
